export const About = () => {
  return (
    <main className="mx-auto max-w-screen-md">
      <h1 className="mb-8 text-2xl font-bold">About</h1>
      <p>just another route/page. should work offline after refreshing</p>
    </main>
  )
}
